<div class="slider-range">
    <input
        type="range"
        [min]="min"
        [max]="max"
        [step]="step"
        [(value)]="value"
        (change)="onChange($event)"
    />
    <output>
        <div class="slider-range-value">
            {{ value }} {{ 'min' | translate }}
        </div>
    </output>
</div>
